// src/router/index.js（或直接在 router/index.js）
import Vue from 'vue'
import Router from 'vue-router'

// 引入页面组件（你可以按需新增多个）
import index from '@/views/index.vue'
import About from '@/views/About.vue'

Vue.use(Router)

export default new Router({
  mode: 'history', // 或 'hash'，看你部署环境
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/about',
      name: 'About',
      component: About
    }
  ]
})
